/** True for `/docs` and any `/docs/<slug>`. */
export function isDocsPath(pathname: string): boolean {
  return pathname === "/docs" || pathname.startsWith("/docs/");
}

/** `/docs` → `index`; `/docs/guardrails` → `guardrails`. */
export function docsSlugFromPath(pathname: string): string {
  const stripped = pathname.replace(/^\/docs\/?/, "").replace(/\/+$/, "");
  return stripped || "index";
}
